export default __webpack_public_path__ + "static/media/avatar.97e3ece6.svg";